<div class="container">
  <div class="row pt-5">
    <div class="col">
      <div class="card">
        <div *ngIf="!cancelled" class="card-body text-center">
          <p *ngIf="type == 'Correo electrónico'">{{"cancel-request.question-email" | translate }}</p>
          <p *ngIf="type == 'Celular'">{{"cancel-request.question-phone" | translate }}</p>
          <button type="button" class="btn btn-success" [disabled]="!button" (click)="cancelRequest()">{{"cancel-request.yes" | translate }}</button>
        </div>
        <div *ngIf="cancelled" class="card-body text-center">
          <div class="alert alert-success">
            <p *ngIf="type == 'Correo electrónico'">{{"cancel-request.confirmation-email" | translate }}</p>
            <p *ngIf="type == 'Celular'">{{"cancel-request.confirmation-phone" | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
